import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { RouterLink } from "@angular/router";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { TranslatePipe } from "@ngx-translate/core";
import { ILeverantorsorderListResponse } from "../../models/leverantororder-models";
import { LeverantorsorderViewModel } from "./leverantorsorderViewModel";

@Component({
    selector: "rask-leverantorsorder-list",
    templateUrl: "./leverantorsorder-list.component.html",
    styleUrls: ["./leverantorsorder-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ListComponent,
        ListColumnDirective,
        RouterLink,
        TranslatePipe
    ]
})
export class LeverantorsorderListComponent {
    leverantorsordrar: ILeverantorsorderListResponse[];
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("leverantorsordrar") set list(val: any) {
        if (!val) {
            return;
        }

        this.leverantorsordrar = val.leverantorsorderList.map(x => new LeverantorsorderViewModel(x));
    }
}
